module.exports = __webpack_public_path__ + "assets/images/modal_save.b0974e36.png";